import { render, staticRenderFns } from "./ReturnPartsDetailValue.vue?vue&type=template&id=05200369"
import script from "./ReturnPartsDetailValue.vue?vue&type=script&lang=js"
export * from "./ReturnPartsDetailValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05200369')) {
      api.createRecord('05200369', component.options)
    } else {
      api.reload('05200369', component.options)
    }
    module.hot.accept("./ReturnPartsDetailValue.vue?vue&type=template&id=05200369", function () {
      api.rerender('05200369', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/returnparts/ReturnPartsDetailValue.vue"
export default component.exports